"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const BaseTemplate_1 = __importDefault(require("./BaseTemplate"));
const CD_Login_screen_Picture_quxto6_c_scale_w_1400_jpg_1 = __importDefault(require("../resources/CD_Login_screen_Picture_quxto6_c_scale,w_1400.jpg"));
exports.default = ({ topBar, body, offlineMessage = "", dashboard }) => {
    return ((0, jsx_runtime_1.jsxs)(BaseTemplate_1.default, { offlineMessage: offlineMessage, topBar: topBar, dashboard: dashboard, children: [(0, jsx_runtime_1.jsx)(Content, { className: "content", children: body }, void 0), (0, jsx_runtime_1.jsx)(Aside, { children: (0, jsx_runtime_1.jsx)("img", { sizes: "(max-width: 1400px) 100vw, 1400px", src: CD_Login_screen_Picture_quxto6_c_scale_w_1400_jpg_1.default, alt: "coaches" }, void 0) }, void 0)] }, void 0));
};
const Content = styled_components_1.default.section `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  display: flex;
  flex: 3;
  height: 100%;
`;
const Aside = styled_components_1.default.aside `
  background-color: grey;
  flex: 4;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    display: none;
  }
`;
//# sourceMappingURL=FormTemplate.js.map